export default {
  en: {
    title: "Users List",
    users_count: "{n} user | {n} users",
    create_user_btn: "Create New User",
    refresh: "Refresh",
    refreshing: "Refreshing...",
    user_max_reached: "Users max has benn reached",
    users_table_title: "System Users",
    head_userid: "User",
    head_user_name: "Full Name",
    head_user_type: "Type",
    head_user_status: "Status",
    head_user_phone: "Phone",
    head_user_omni: "Omni Channel",
    head_user_start: "Start",
    head_user_action: "Action",
    user_type_agent: "Agent",
    user_type_supervisor: "Supervisor",
    user_type_admin: "Admin",
    user_type_wallboard: "Wallboard",
    user_status_online: "Online",
    user_status_offline: "Offline",
    user_status_busy: "Not Ready",
    user_Status_rest: "Rest",
    user_permission_phone: "Phone",
    user_permission_omni: "Omni Channel",
    user_permission_alert: "SLA Alerting",
    user_permission_campaigns: "IVR Campaigns",
    user_manage_btn: "Manage",
    reset_password_title: "Reset User Password",
    deactivate_user: "Deactivate User",
    deactivate_user_text: "Are you sure you want to deactivate {name}?",
    deactivate_user_btn: "Yes, deactivate it!",
    activate_user: "Activate User",
    activate_user_text: "Are you sure you want to activate {name}?",
    activate_user_btn: "Yes, activate it!",
    delete_user: "Delete User",
    delete_user_text: "Are you sure you want to delete {name}?",
    delete_user_btn: "Yes, delete it!",
    validation: {
      username_missing: "Username is required",
      username_minimum: "Username minimum length is 3 digits",
      username_max: "Username max length is 5 digits",
      username_is_number: "Username must extension number",
      password_missing: "Password is required",
      password_rules: "Password must have characters and numbers",
      password_min_lenght: "Password must be 10 or more characters",
      fullname_missing: "Full name is required",
      phone_invalid: "Invalid phone Number",
      phone_minimum: "Phone nummber minimum is 10 digits",
      phone_maximum: "Phone number maximum is 12 digits",
      email_invalid: "Email is not valid",
      confirm_password_missing: "passwords are not matching",
      date_invalid: "Invalid date value",
      start_date_required: "start date is required",
      password_not_matching: "Password must match",
      username_exist: "Username already exist",
      username_range: "Username is out of allowed range",
    },
    create_user: {
      title: "Create New User",
      title_ID: "User Identification",
      username: "Username",
      username_hint: "Allowed range is",
      fullname: "Full Name",
      title_contact: "Contact Information(Optional)",
      number: "Phone Number",
      email: "Email",
      title_security: "User Security",
      password: "Password",
      password_confirm: "Confirm Password",
      title_user_type: "Choose User Type",
      type_limit_reached: "(max limit reached)",
      title_validity: "Set Validity Period (Optional)",
      expire_check: "set expiration date for the user",
      start_date_placeholder: "Set Start Date ...",
      expire_date_placeholder: "Set Expire Date ...",
      title_skill_choose: "Choose user queues",
      title_skill_mandatory: "(Mandatory for Agents)",
      create_btn: "Add",
      clear_btn: " Clear",
    },
    manage_user: {
      title: "Manage User {user}",
      tab_info: "Info",
      tab_edit: "Edit",
      tab_settings: "Settings",
      tab_status: "Status",
      tab_validity: "Validity",
      clear_btn: "clear",
      update_user_btn: "UPDATE",
      reset_btn: "Reset",
      info: {
        title: "Basic User Info",
        info_userid: "Username",
        info_fullname: "Full Name",
        info_phone: "Phone",
        info_email: "Email",
        info_start_date: "Started At",
        info_group: "Group",
      },
      edit: {
        title: "Edit Profile",
        new_password: "New Password",
        confirm_password: "Confirm new Password",
      },
      settings: {
        title: "Configure User Type/Queues",
        type_change_check: "Change Type",
        type_change_btn: "Change {user} Type",
        change_skill_check: "Change Queue",
        change_skill_user_select: "Change Queue For {user}",
        change_skill_btn: "Change Queue",
        callerid_check: "Set callerID",
        callerid: "CallerID",
        callerid_btn_info: "Set the user caller number when dialing out",
        callerid_btn: "Set {user} CallerID",
        forwarding_check: "Set Forwarding",
        forward_number: "Forward Phone Number",
        enable_forwarding_btn: "Enable Forwarding",
        disable_forwarding_btn: "Disable Forwarding",
      },
      status: {
        title: "User Status",
        in_session: "{user} in Session.....",
        not_in_session: "Not in Session",
        login_btn: "Login {user}",
        logout_btn: "Logout {user}",
      },
      validity: {
        title: "Set User Validity",
        expire_time_check: "set user expire time",
        expire_time_subtitle: "Expired At:",
        expire_time_placeholder: "Set Expire Date ...",
        expire_btn: "Set Expire",
        expire_reset_btn: "Clear Expire",
        delete_user_btn: "Delete {user}",
        enable_user_btn: "Enable",
        disable_user_btn: "Disable",
      },
    },
  },
  ar: {
    title: "مجموعة المستخدمين",
    users_count:
      "{n} مستخدم | مستخدم واحد | مستخدمان | {n} مستخدمين | {n} مستخدم | {n} مستخدم",
    create_user_btn: "إضافة موظف",
    refresh: "تحديث",
    refreshing: "جاري التحديث...",
    user_max_reached: "تم الوصول للحد الأقصى من المستخدمين",
    users_table_title: "مستخدمي النظام",
    head_userid: "المستخدم",
    head_user_name: "الاسم",
    head_user_type: "النوع",
    head_user_status: "الحالة",
    head_user_phone: "هاتف",
    head_user_omni: "وسائل التواصل",
    head_user_start: "البداية",
    head_user_action: "ادارة",
    user_type_agent: "موظف",
    user_type_supervisor: "مشرف",
    user_type_admin: "مدير",
    user_type_wallboard: "لوحة العرض",
    user_status_online: "متصل",
    user_status_offline: "غير متصل",
    user_status_busy: "غير مستعد",
    user_Status_rest: "راحة",
    user_permission_phone: "هاتف",
    user_permission_omni: "وسائل التواصل",
    user_permission_alert: "تنبيه",
    user_permission_campaigns: "حملات الرد الآلي",
    user_manage_btn: "تعديل",
    reset_password_title: "إعادة تعيين كلمة مرور المستخدم",
    deactivate_user: "إلغاء تفعيل المستخدم",
    deactivate_user_text: "هل أنت متأكد من إلغاء تفعيل {name}؟",
    deactivate_user_btn: "نعم, إلغاء تفعيله!",
    activate_user: "تفعيل المستخدم",
    activate_user_text: "هل أنت متأكد من تفعيل {name}؟",
    activate_user_btn: "نعم, تفعيله!",
    delete_user: "حذف المستخدم",
    delete_user_text: "هل أنت متأكد من حذف {name}؟",
    delete_user_btn: "نعم, حذفه!",
    validation: {
      username_missing: "المعرف غير محدد",
      username_minimum: "أقل طول 3 خانات",
      username_max: "أكبر طول 5 خانات",
      username_is_number: "المعرف يجب ان يكون رقم",
      password_missing: "كلمة المرور غير محددة",
      password_rules: "كلمة المرور يجب أن تحتوي أرقام وحروف",
      password_min_lenght: "أقل طول 10 خانات",
      fullname_missing: "الإسم غير محدد",
      phone_invalid: "رقم الهاتف غير صحيح",
      phone_minimum: "أقل طول 10 خانات ابتداء بالصفر",
      phone_maximum: "أكبر طول 12 خانة",
      email_invalid: "البريد الإلكتروني غير صحيح",
      confirm_password_missing: "كلمتا المرور مختلفتان",
      date_invalid: "تاريخ غير صحيح",
      start_date_required: "تاريخ البدأ غير محدد",
      password_not_matching: "كلمتا المرور يجب أن يتساويا",
      username_exist: "المعرف موجود مسبقا",
      username_range: "المعرف خارج النطاق المسموح",
    },
    create_user: {
      title: "انشاء مستخدم جديد",
      title_ID: "تعريف المستخم",
      username: "معرف المستخدم",
      username_hint: "معرف المستخدم يجب ان يكون في نطاق",
      fullname: "الاسم كامل",
      title_contact: "بيانات التواصل (اختياري)",
      number: "رقم الهاتف",
      email: "البريد الإلكتروني",
      title_security: "الامن",
      password: "كلمة المرور",
      password_confirm: "تأكيد كلمة المرور",
      title_user_type: "اختيار نوع المستخدم",
      type_limit_reached: "(تم الوصول للحد الأقصى)",
      title_validity: "تحديد فترة صلاحية (اختياري)",
      expire_check: "حدد تاريخ انتهاء صلاحية للمستخدم",
      start_date_placeholder: "تحديد تاريخ بداية",
      expire_date_placeholder: "تحديد تاريخ انتهاء",
      title_skill_choose: "اختيار مجموعات للمستخدم",
      title_skill_mandatory: "(إجباري للنوع موظف)",
      create_btn: "إضافة",
      clear_btn: "مسح",
    },
    manage_user: {
      title: "إعدادات المستخدم {user}",
      tab_info: "البيانات",
      tab_edit: "تعديل",
      tab_settings: "إعدادات",
      tab_status: "الحالة",
      tab_validity: "الصلاحية",
      clear_btn: "مسح",
      update_user_btn: "تحديث",
      reset_btn: "إعادة ضبط",
      info: {
        title: "معلومات المستخدم الأساسية",
        info_userid: "المعرف",
        info_fullname: "الاسم",
        info_phone: "رقم الهاتف",
        info_email: "البريد الإلكتروني",
        info_start_date: "بدأ من",
        info_group: "نوع المستخدم",
      },
      edit: {
        title: "تعديل حساب المستخدم",
        new_password: "كلمة سر جديدة",
        confirm_password: "تأكيد كلمة السر الجديدة",
      },
      settings: {
        title: "ضبط نوع/مجموعة المستخدم",
        type_change_check: "تغيير النوع",
        type_change_btn: "تحديث نوع {user}",
        change_skill_check: "تغيير المجموعات",
        change_skill_user_select: "تغيير مجموعات المستخدم {user}",
        change_skill_btn: "تحديث المجموعة",
        callerid_check: "حدد رقم الاتصال",
        callerid: "رقم الاتصال",
        callerid_btn_info: "الرقم المستخدم من الوظف للمكالمات الصادرة",
        callerid_btn: "تحديث الرقم ل {user}",
        forwarding_check: "تحديد رقم التحويل",
        forward_number: "رقم تحويل المكالمات",
        enable_forwarding_btn: "تفعيل التحويل",
        disable_forwarding_btn: "إيقاف التحويل",
      },
      status: {
        title: "حالة المستخدم",
        in_session: "{user} متصل حاليا ....",
        not_in_session: "غير متصل",
        login_btn: "تسجيل دخول {user}",
        logout_btn: "تسجيل خروج {user}",
      },
      validity: {
        title: "تحديد صلاحية المستخدم",
        expire_time_check: "تحديد فترة الصلاحية",
        expire_time_subtitle: "يتوقف عند",
        expire_time_placeholder: "تحديد تاريخ الإنتهاء",
        expire_btn: "تحديث الصلاحية",
        expire_reset_btn: "إلغاء فترة الصلاحية",
        delete_user_btn: "مسح {user}",
        enable_user_btn: "تفعيل {user}",
        disable_user_btn: "إلغاء {user}",
      },
    },
  },
};
